import { render, staticRenderFns } from "./Login-Lab.vue?vue&type=template&id=ac8c4af2&scoped=true&"
import script from "./Login-Lab.vue?vue&type=script&lang=js&"
export * from "./Login-Lab.vue?vue&type=script&lang=js&"
import style0 from "./Login-Lab.vue?vue&type=style&index=0&id=ac8c4af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8c4af2",
  null
  
)

export default component.exports